import React from "react";

class LimitBadge extends React.Component {
    value = "";

    render() {
        let food = this.props.data;
        if (food.dietPortion === food.maxPortion) this.value = "Max";
        else if (food.dietPortion === food.minPortion) this.value = "Min";
        else this.value = "";

        if (this.value !== "") return <span className="glowD">{this.value}</span>;
        else return null;
    }
}

export default LimitBadge;
